import { useEffect, useCallback } from 'react';
export default function TicketRedirect({ getCookie, ostype = '' }) {
  const sendMessage = useCallback(() => {
    if (ostype === 'ios') {
      console.log('ios');
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.toggleMessageHandler
      ) {
        window.webkit.messageHandlers.toggleMessageHandler.postMessage({
          message: 'done',
        });
      }
    } else if (ostype === 'android') {
      console.log('android');
      if (window.JSBridge && window.JSBridge.showMessageInNative)
        window.JSBridge.showMessageInNative('done');
    }
  }, [ostype]);

  useEffect(() => {
    if (ostype === 'ios' || ostype === 'android') {
      window.onload = sendMessage;
    } else {
      window.scrollTo(0, 0);
      const redirect =
        (window.location.hostname === 'localhost' &&
          `http://localhost:3000/order/ticket/${getCookie('hostedTransactionIdentifier')}`) ||
        (window.location.hostname === 'qa-cart.terramarbrandsusa.com' &&
          `https://qa-cart.terramarbrandsusa.com/order/ticket/${getCookie(
            'hostedTransactionIdentifier',
          )}`) ||
        `https://cart.terramarbrandsusa.com/order/ticket/${getCookie(
          'hostedTransactionIdentifier',
        )}`;
      //window.location.replace(redirect);
      //window.frames['TMBcheckout'].location = redirect;
      window.top.location.href = redirect;
    }
  }, [getCookie, ostype, sendMessage]);

  return <div>Redirect...{ostype}</div>;
}
